import { render, staticRenderFns } from "./CardModalDetails.vue?vue&type=template&id=3bfa8729&scoped=true"
import script from "./CardModalDetails.vue?vue&type=script&lang=js"
export * from "./CardModalDetails.vue?vue&type=script&lang=js"
import style0 from "./CardModalDetails.vue?vue&type=style&index=0&id=3bfa8729&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfa8729",
  null
  
)

export default component.exports